'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var ReactDOM = _interopDefault(require('react-dom'));
var wireframe = require('./wireframe.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-loader-content',
    cnFullscreen = "".concat(CLASSNAME, "--fullscreen"),
    cnNoHeight = "".concat(CLASSNAME, "--no-height"),
    cnLoader = "".concat(CLASSNAME, "__loader"),
    cnImage = "".concat(CLASSNAME, "__image"),
    cnDot = "".concat(CLASSNAME, "__dot");
/**
 * 
 */

function LoaderContent(_ref) {
  var _classNames2;

  var className = _ref.className,
      contentPlaceholder = _ref.contentPlaceholder,
      delay = _ref.delay,
      fullscreen = _ref.fullscreen,
      noHeight = _ref.noHeight;

  var _useState = React.useState(!delay),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var timer;
  React.useEffect(function () {
    if (delay) {
      timer = setTimeout(function () {
        setVisible(true);
      }, delay);
    }

    return function () {
      clearTimeout(timer);
    };
  }, []);

  function renderLoader() {
    if (contentPlaceholder) {
      return /*#__PURE__*/React__default.createElement(wireframe, {
        className: cnImage
      });
    }

    return /*#__PURE__*/React__default.createElement("div", {
      className: cnLoader
    }, /*#__PURE__*/React__default.createElement("div", {
      className: cnDot
    }), /*#__PURE__*/React__default.createElement("div", {
      className: cnDot
    }), /*#__PURE__*/React__default.createElement("div", {
      className: cnDot
    }), /*#__PURE__*/React__default.createElement("div", {
      className: cnDot
    }), /*#__PURE__*/React__default.createElement("div", {
      className: cnDot
    }), /*#__PURE__*/React__default.createElement("div", {
      className: cnDot
    }), /*#__PURE__*/React__default.createElement("div", {
      className: cnDot
    }), /*#__PURE__*/React__default.createElement("div", {
      className: cnDot
    }));
  }

  if (!visible) {
    return null;
  }

  var el = typeof document !== 'undefined' ? document.querySelector('#stageFullscreen') : null;

  if (fullscreen && el) {
    var _classNames;

    return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React__default.createElement("div", {
      className: classNames(CLASSNAME, className, (_classNames = {}, _rollupPluginBabelHelpers.defineProperty(_classNames, cnFullscreen, fullscreen), _rollupPluginBabelHelpers.defineProperty(_classNames, cnNoHeight, noHeight), _classNames))
    }, renderLoader()), el);
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className, (_classNames2 = {}, _rollupPluginBabelHelpers.defineProperty(_classNames2, cnFullscreen, fullscreen), _rollupPluginBabelHelpers.defineProperty(_classNames2, cnNoHeight, noHeight), _classNames2))
  }, renderLoader());
}
LoaderContent.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** */
  contentPlaceholder: PropTypes.bool,

  /** */
  delay: PropTypes.number,

  /** */
  fullscreen: PropTypes.bool,

  /** */
  noHeight: PropTypes.bool
};
LoaderContent.defaultProps = {
  delay: 100
};

module.exports = LoaderContent;
